<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onChangeCompany="onChangeCompany"
        @editAndAdd="editAndAdd"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <question-modal
      ref="formRef"
      :visible="visible"
      :title="title"
      :btn-is-loading="btnIsLoading"
      @onCancel="onCancel"
      @handleSubmit="onSubmit"
    />
  </div>
</template>
<script>
const uuidv1 = require('uuid/v1');
import { columns } from './data/index';
import { getType, getCompany } from './utils/dealTable';
import QuestionModal from './modal/index.vue';
import TableSearch from './components/search';
export default {
  components: { QuestionModal, TableSearch},
  data() {
    return {
      selectData: [],
      columns,
      tableData: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      visible: false,
      title: '',
      templateId: undefined,
      btnIsLoading: false,
      keyword: '',
      company_id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      page: this.current,
      pageSize: this.pageSize,
      keyword: this.keyword,
      polymorphic_type: 1,
      company_id: this.company_id,
    });
  },
  methods: {

    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/Questionnaire/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.name,
            aim: item.aim,
            data: item,
          };
          temp.push(obj);
        });
        this.tableData = temp;
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      this.visible = true;
      if (!record) {
        // 新增
        this.title = '新增调研模板';
        this.templateId = '';
        this.$nextTick(() => {
          this.$refs.formRef.form.resetFields();
        });
      } else {
        // 编辑
        this.templateId = record.id;
        this.title = '编辑调研模板';
        this.$nextTick(() => {
          let data = {
            company_id: record.data.company_id,
            name: record.data.name,
            aim: record.data.aim,
            question_ids: record.data.link_question_list.map((item)=>item.question_id),
          };
          this.$refs.formRef.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.form.validateFields(
        async(err, values) => {
          console.log('TCL: onSubmit -> values', values);
          if (!err) {
            let data={
              name: values.name,
              aim: values.aim,
              question_ids: values.question_ids.join(),
              company_id: values.company_id,
            };
            this.btnIsLoading=true;
            let result = await this.$http.post('/Questionnaire/update', {
              ...data,
              id: this.templateId ? this.templateId : '',
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.visible = false;
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
                keyword: this.keyword,
                polymorphic_type: 1,
                company_id: this.company_id,
              });
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/Questionnaire/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: 1,
          company_id: this.company_id,
        });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/Questionnaire/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: 1,
          company_id: this.company_id,
        });
      }
    },
    // 搜索
    onSearch(keyword){
      this.current=1;
      this.keyword=keyword;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        polymorphic_type: 1,
        company_id: this.company_id,
      });
    },
    // 选择企业
    onChangeCompany(value){
      this.current=1;
      this.company_id=value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        polymorphic_type: 1,
        company_id: this.company_id,
      });
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        polymorphic_type: 1,
        company_id: this.company_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
